import React, { ReactElement } from "react";
import classNames from "classnames";
import { LinkProps } from "./link.types";

export const Link = ({
  children,
  className,
  href,
  underline,
  ...rest
}: LinkProps): ReactElement => {
  const linkClasses = classNames(
    {
      "spark-link": !underline,
      "spark-link--underline": underline,
    },
    className
  );

  return (
    <a href={href} className={linkClasses} {...rest}>
      {children}
    </a>
  );
};

Link.displayName = "Link";
